import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable';

/**
 * import rxjs operator
 */

import { HttpClientService } from '../../../shared';
import { environment } from '../../../';
import { User } from '../../model';
import { AuthTypes, ApiEndpoints } from '../../constant';

@Injectable()
export class LoginService {

  isLoggedIn: boolean = false;
  constructor(private httpClient: HttpClientService) { }
  
  /**
   * call user login api
   */
  login(user): Observable<User> { 
    this.isLoggedIn = true;
    return this.httpClient.post(ApiEndpoints.authenticate, user);
  }

  /**
   * Register user
   */
  register(user): Observable<any> {
    let reg = this.httpClient.post(ApiEndpoints.users, user);
    return reg;
  }

  /**
   * Login redirect function
   */
  loginByaccessToken(token): Observable<User> {
    this.isLoggedIn = true;
    return this.httpClient.post(ApiEndpoints.authByToken, { token: token });
  }

  /**
   * call user login api
   */
  loginWithMobile(user): Observable<User> {
    this.isLoggedIn = true;
    return this.httpClient.post(ApiEndpoints.authenticateViaMobile, user);
  }

  loginExistingEmail(user): Observable<any> {
    this.isLoggedIn = true;
    return this.httpClient.post(ApiEndpoints.migrateEmailUsers, user );
  }

  /**
   * rest password with username
   */
  resetPassword(email): Observable<User> {
    return this.httpClient.post(ApiEndpoints.forgetPassword, { email });
  }

  logout(): void {
    this.isLoggedIn = false;
  }

  /**
   * kaushalya
   * 2017-11-01
   * get buy item
   */
  getGoingToBuyItemStatus(cartItems){
    return this.httpClient.authPost(ApiEndpoints.getToBuyItemStatus, { cartItems });
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/login/services/login.service.ts